import Vue from 'vue'
import Router from 'vue-router'

import Purchase from '@/page/purchase/Purchase'
import Success from '@/page/success/Success'
import Fail from '@/page/fail/Fail'

//登录页面
import Log from '@/page/log/Log'
import Register from '@/page/register/Register'
import RegisterStudent from '@/page/register/RegisterStudent'
import RegisterTeacher from '@/page/register/RegisterTeacher'
import Fillin from '@/page/register/Fillin'
import FillinStudent from '@/page/register/FillinStudent'
import Invite from '@/page/register/Invite'


import Account from '@/page/account/Account'
import Personal from '@/page/account/personal/Personal'
import UserSchedule from '@/page/account/personal/schedule/Schedule'
import MyLesson from '@/page/account/personal/mylesson/Mylesson'
import BoughtInfo from '@/page/boughtinfo/BoughtInfo'
import TestUrl from '@/page/account/personal/testurl//TestUrl'
import TestLive from '@/page/account/personal/testlive//TestLive'
import SHomeWork from '@/page/account/personal/work//work'

import Console from '@/page/console/Console'
import Order from '@/page/order/Order'
import AllOrder from '@/page/order/allorders/AllOrders'
import Pupils from '@/page/pupils/Pupils'
import PupilsList from '@/page/pupils/pupilslist/PupilsList'
import School from '@/page/school/School'
import SchoolInfo from '@/page/school/schoolinfo/SchoolInfo'
import AddWareSchool from '@/page/school/schoolinfo/addware/AddWare'
import SchoolMember from '@/page/school/schoolmember/SchoolMember'
import SchoolSet from '@/page/school/schoolset/SchoolSet'
import Lesson from '@/page/lesson/Lesson'
import Class from '@/page/class/Class'
import ClassSchedule from '@/page/class/schedule/Schedule'
import ClassMember from '@/page/class/classmember/ClassMember'
import ClassCoupon from '@/page/class/classcoupon/ClassCoupon'
import LessonSchedule from '@/page/lesson/lessonschedule/LessonSchedule'
import AddWare from '@/page/lesson/lessonschedule/addware/AddWare'
import LessonWare from '@/page/lesson/lessonware/LessonWare'
import LessonCoupon from '@/page/lesson/lessoncoupon/LessonCoupon'
import Appoint from '@/page/lesson/appoint/Appoint'

//作业
import Homework from '@/page/teacherhomework/homework'
import homeworkundone from '@/page/teacherhomework/undone/undone'
import homeworkdone from '@/page/teacherhomework/done/done'
import assignwork from '@/page/teacherhomework/create/assignwork'

import homeworkFatherPath from '@/page/homework/homework'
import teacherinithomework from '@/page/homework/homeworkinit/homeworkinit'
import sworkedit from '@/page/homework/sworkedit/sworkedit'
import sworkcomplete from '@/page/homework/scomplete/scomplete'

//统计结算页面
import Statistic from '@/page/statistic/Statistic'
import EnrollStatistic from '@/page/statistic/enrollstatistic/EnrollStatistic'
import CourseStatistic from '@/page/statistic/coursestatistic/CourseStatistic'
import StatisticList from '@/page/statistic/staticlist/staticlist'
import StatisticInfo from '@/page/statistic/statisticinfo/statisticinfo'

import Activity from '@/page/activity/Activity'
import ActivityCoupon from '@/page/activity/activitycoupon/ActivityCoupon'

//试听确认
import ConfrimEnroll from '@/page/confirmenroll/ConfirmEnroll'
import ConfirmClass from '@/page/confirmenroll/confirmclass/ConfirmClass'

//课程日历
import CalendarList from '@/page/calendarlist/CalendarList'
import TeacherTimeTable from '@/page/calendarlist/timetable/timetable'
import ChangeSchoolTime from '@/page/calendarlist/changeschooltime/ChangeSchoolTime'

//后台直播测试
import ConsoleLive from '@/page/live/live'
import ConsoleLiveTest from '@/page/live/livetest/livetest'

//文件管理
import Files from '@/page/files/Files'

import Chat from '@/page/chat/chat'

import NotFound from '@/page/notfound/404'

// 我的资料
import MyProfile from '@/page/myProfile/MyProfile'

Vue.use(Router);

var router = new Router({
  routes: [
    {
      path: '',
      redirect: '/account'
    },
    {
      path:'/404',
      component:NotFound,
      meta: {
        title: '未发现该页面'
      }
    },
    {
      path: '/log',
      component: Log,
      meta: {
        title: '账号登录-全优在线在线1对1'
      }
    },
    {
      path: '/register',
      component: Register,
      meta: {
        title: '注册-全优在线在线1对1'
      }
    },
    {
      path: '/register-student',
      component: RegisterStudent,
      meta: {
        title: '学生注册-全优在线在线1对1'
      }
    },
    {
      path: '/register-teacher',
      component: RegisterTeacher,
      meta: {
        title: '老师注册-全优在线在线1对1'
      }
    },
    {
      path: '/fillin',
      component: Fillin,
      meta: {
        title: '完善资料-全优在线在线1对1'
      }
    },
    {
      path:'/invite',
      component:Invite,
      meta:{
        title:'邀请注册-全优在线1对1'
      }
    },
    {
      path: '/fillstudent',
      component: FillinStudent,
      meta: {
        title: '完善资料-全优在线在线1对1'
      }
    },
    {
      path: '/account',
      component: Account,
      redirect: '/account/personal/schedule',
      children: [
        {
          path: 'personal',
          component: Personal,
          redirect: '/account/personal/schedule',
          children: [
            {
              path: 'schedule',
              component: UserSchedule,
              meta: {
                title: '我的课程表'
              },
            },
            {
              path: 'lesson',
              component: MyLesson,
              meta: {
                title: '我的课程'
              },
            },
            {
              path: 'work',
              component: SHomeWork,
              meta: {
                title: '作业管理'
              },
            },
            // {
            //   path: 'testlive',
            //   component: TestLive,
            //   meta: {
            //     title: '直播测试'
            //   },
            // },
            {
              path: 'testurl',
              component: TestUrl,
              meta: {
                title: '设备测试'
              },
            }
          ]
        },
      ]
    },
    {
      path: '/boughtinfo',
      component: BoughtInfo,
      meta: {
        title: '课程信息'
      },
    },
    {
      path: '/console',
      component: Console,
      redirect: '/console/calendar/timetable',
      children: [
        {
          path: 'school',
          component: School,
          redirect: '/console/school/info',
          children: [
            {
              path: 'info',
              component: SchoolInfo,
              meta: {
                title: '网校首页'
              },
              children: [
                {
                  path: 'add',
                  component: AddWareSchool,
                  meta: {
                    title: '添加课件'
                  },
                }
              ]
            },
            {
              path: 'member',
              component: SchoolMember,
              meta: {
                title: '网校成员'
              },
            },
            {
              path: 'set',
              component: SchoolSet,
              meta: {
                title: '网校设置'
              },
            }
          ]
        },
        {
          path: 'lesson/class/schedule', // 修正之前路由嵌套的问题
          component: ClassSchedule,
          meta: {
            title: '课程表'
          },
        },
        {
          path: 'lesson/class/member',
          component: ClassMember,
          meta: {
            title: '班级成员'
          },
        },
        {
          path: 'lesson',
          component: Lesson,
          meta: {
            title: '课程列表'
          },
          children: [
            {
              path: 'class',
              name: 'class',
              component: Class,
              meta: {
                title: '班级管理'
              },
              children: [
                {
                  path: 'schedule',
                  component: ClassSchedule,
                  meta: {
                    title: '课程表'
                  },
                },
                {
                  path: 'member',
                  component: ClassMember,
                  meta: {
                    title: '班级成员'
                  },
                },
                // {
                //   path: 'coupon',
                //   component: ClassCoupon,
                //   meta: {
                //     title: '班级优惠券'
                //   },
                // }
              ]
            },
            // {
            //   path: 'schedule',
            //   component: LessonSchedule,
            //   meta: {
            //     title: '课程表',
            //   },
            //   children: [
            //     {
            //       path: 'add',
            //       component: AddWare,
            //       meta: {
            //         title: '添加课件',
            //       }
            //     }
            //   ]
            // },
            // {
            //   path: 'coupon',
            //   component: LessonCoupon,
            //   meta: {
            //     title: '课程优惠券',
            //   }
            // },
            {
              path: 'ware',
              component: LessonWare,
              meta: {
                title: '课件管理',
              }
            },
            {
              path: 'appoint',
              component: Appoint,
              meta: {
                title: '课程预约',
              }
            }
          ]
        },
        {
          path: 'homework',
          component: Homework,
          redirect: '/console/homework/undone',
          meta: {
            title: '作业管理'
          },
          children: [
            {
              path: 'create',
              component: assignwork,
              meta: {
                title: '创建作业'
              },
            },
            {
              path: 'undone',
              component: homeworkundone,
              meta: {
                title: '未批改'
              },
            },
            {
              path: 'done',
              component: homeworkdone,
              meta: {
                title: '已批改'
              },
            },
          ]
        },
        {
          path: 'order',
          component: Order,
          redirect: '/console/order/all',
          children: [
            {
              path: 'all',
              component: AllOrder,
              meta: {
                title: '订单管理',
              },
            }
          ]
        },
        {
          path:'pupils',
          component:Pupils,
          redirect: '/console/pupils/list',
          children: [
            {
              path: 'list',
              component: PupilsList,
              meta: {
                title: '生源列表',
              },
            }
          ]
        },
        {
          path: 'statistic',
          component: Statistic,
          redirect: '/console/statistic/enroll',
          children: [
            {
              path: 'enroll',
              component: EnrollStatistic,
            },
            {
              path: 'order',
              component: AllOrder,
            },
            {
              path: 'course',
              component: CourseStatistic,
            },{
              path: 'list',
              component: StatisticList,
            },{
              path: 'info/:classid(\\d+)',
              component: StatisticInfo,
            }
          ]
        },
        {
          path: 'calendar',
          component: CalendarList,
          redirect: '/console/calendar/timetable',
          children: [
            {
              path: 'timetable',
              component: TeacherTimeTable,
            },
            {
              path: 'schooltime',
              component: ChangeSchoolTime,
            }
          ]
        },
        {
          path: 'confirm',
          component: ConfrimEnroll,
          redirect: '/console/confirm/class',
          children: [
            {
              path: 'class',
              component: ConfirmClass,
            }
          ]
        },
        {
          path: 'files',
          component: Files,
          //redirect: '/console/live/test',
        },
        {
          path: 'live',
          component: ConsoleLive,
          redirect: '/console/live/test',
          children: [
            {
              path: 'test',
              component: ConsoleLiveTest,
            }
          ]
        },
        {
          path: 'myProfile',
          component: MyProfile,
          meta: {
            title: '我的资料'
          }
        },
        // {
        //   path: 'activity',
        //   component: Activity,
        //   redirect: '/console/activity/coupon',
        //   children: [
        //     {
        //       path: 'coupon',
        //       component: ActivityCoupon,
        //       meta: {
        //         title: '网校优惠券',
        //       }
        //     }
        //   ]
        // }
      ]
    },
    {
      path:'/homework',
      component:homeworkFatherPath,
      redirect: '/homework/init',
      children: [
        {
          path: 'init',
          component: teacherinithomework,
          meta: {
            title: '编辑作业',
          }
        },
        {
          path: 'sedit',
          component: sworkedit,
          meta: {
            title: '完成作业',
          }
        },{
          path: 'complete',
          component: sworkcomplete,
          meta: {
            title: '查看作业',
          }
        }
      ]
    },
    {
      path: '/purchase',
      component: Purchase,
      meta: {
        title: '购买',
      }
    },
    {
      path: '/success',
      component: Success,
      meta: {
        title: '购买成功',
      }
    },
    {
      path: '/fail',
      component: Fail,
      meta: {
        title: '购买失败',
      }
    },
    {
      path: '/chat',
      name: 'chat',
      component: Chat,
      meta: {
        title: '聊天',
      }
    },
    {path: '*', redirect: '/404',}
  ]
});
router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title || '全优在线-高中小学生在线教育专家';
  next()
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js